import React, { useEffect } from "react";
import SubscriptionModal from "../../../components/Modals/SubscriptionModal";
import { Link, useParams } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { IoArrowForward } from "react-icons/io5";
import { RxExclamationTriangle } from "react-icons/rx";
import {
  loggedInUser,
  subscriptionPackages,
  subscribedPackage,
  teamSubscribedPackage,
  userIDCheck,
  teamIDCheck,
  accountType,
} from "../../../utils/store";
import { useAtom } from "jotai";
import Loader from "../../Loader";
import { useState } from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { AiFillCheckCircle } from "react-icons/ai";
import { loadStripe } from "@stripe/stripe-js";
import { get, post } from "../../../server";
import {
  CANCEL_SUBSCRIPTION,
  COUPON_APPLY,
  GET_USER_SUBSCRIPTION,
  PACKAGES_LISTING,
} from "../../../utils/constants/apiUrl";
import { IoSend } from "react-icons/io5";
import showToast from "../../../helpers/showToast";
import { Button, Card, Col, Modal, Nav, Row } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import { trackEvent } from "../../../utils/mixpanel";
import SubscriptionCard from "../../SubscriptionCard";
import {
  elementsOptions,
  stripePromise,
} from "../../../utils/constants/stripeConfig";
import { TRANSACTION } from "../../../utils/constants/apiUrl";

const Subscription = () => {
  const { teamId } = useParams();
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [purchasePackages, setPurchasePackages] = useAtom(subscriptionPackages);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [teamPurchasedPackage, setTeamPurchasedPackage] = useAtom(teamSubscribedPackage);
  const [purchasedPackageData, setPurchasedPackageData] = useState();
  const [selectedPackage, setSelectedPackage] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [subscriptions, setSubscriptions] = useState(purchasePackages);
  const [personalAccount] = useAtom(accountType);
  const [userTeamId] = useAtom(teamIDCheck);
  const [userID] = useAtom(userIDCheck);

  // Simple: use the appropriate atom based on account type
  const activePurchasedPackage = !personalAccount ? teamPurchasedPackage : purchasedPackage;
  const setActivePurchasedPackage = !personalAccount ? setTeamPurchasedPackage : setPurchasedPackage;
  
  console.log("[Subscription Render] personalAccount:", personalAccount);
  console.log("[Subscription Render] userTeamId:", userTeamId);
  console.log("[Subscription Render] purchasedPackage:", purchasedPackage);
  console.log("[Subscription Render] teamPurchasedPackage:", teamPurchasedPackage);
  console.log("[Subscription Render] activePurchasedPackage:", activePurchasedPackage);
  console.log("[Subscription Render] localStorage teamPurchasedPackage:", localStorage.getItem("teamPurchasedPackage"));
  console.log("[Subscription Render] localStorage purchasedPackage:", localStorage.getItem("purchasedPackage"));
  
  const [loading, setLoading] = useState(false);
  const [activeKeys, setActiveKeys] = useState([]);
  const [selectedSubscriptionType, setSelectedSubscriptionType] =
    useState("monthly");
  const [couponCode, setCouponCode] = useState("");
  const [hasCouponMonthly, setHasCouponMonthly] = useState([]);
  const [hasCouponYearly, setHasCouponYearly] = useState([]);
  const [blankCouponField, setBlankCouponField] = useState(false);
  const [correctCouponEntered, setCorrectCouponEntered] = useState(false);
  const [incorrectCouponEntered, setIncorrectCouponEntered] = useState(false);
  const [couponMessage, setCouponMessage] = useState("");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [deviceType, setDeviceType] = useState("");
  const [autoRenew, setAutoRenew] = useState();
  const [couponData, setCouponData] = useState(null);
  const creationDate = new Date(activePurchasedPackage?.end_date);
  const [activeTab, setActiveTab] = useState("monthly");
  const currentDate = new Date();
  const [freeTrialMessage, setFreeTrialMessage] = useState("");
  const [cancelLoading, setCancelLoading] = useState(false);

  // CRITICAL: Restore from localStorage IMMEDIATELY on mount before any other logic
  useEffect(() => {
    console.log("[Subscription Mount] Checking localStorage on mount");
    
    if (!personalAccount && userTeamId) {
      const storedTeamPackage = localStorage.getItem("teamPurchasedPackage");
      console.log("[Subscription Mount] Team mode - stored package:", storedTeamPackage);
      
      if (storedTeamPackage && storedTeamPackage !== "null" && storedTeamPackage !== "{}") {
        try {
          const parsed = JSON.parse(storedTeamPackage);
          console.log("[Subscription Mount] Restoring team package from localStorage:", parsed);
          
          if (parsed && Object.keys(parsed).length > 0) {
            setTeamPurchasedPackage(parsed);
            setPurchasedPackage(parsed);
          }
        } catch (e) {
          console.error("[Subscription Mount] Error parsing stored team package:", e);
        }
      } else if (loggedUser?.package_details?.length > 0) {
        // Fallback: restore from loggedUser if localStorage is empty
        const teamPackage = loggedUser.package_details.find(
          (pkg) => pkg.team_id == userTeamId
        );
        
        if (teamPackage) {
          const packageToRestore = teamPackage?.package || teamPackage;
          console.log("[Subscription Mount] Restoring from loggedUser.package_details:", packageToRestore);
          
          if (packageToRestore && Object.keys(packageToRestore).length > 0) {
            localStorage.setItem("teamPurchasedPackage", JSON.stringify(packageToRestore));
            setTeamPurchasedPackage(packageToRestore);
            setPurchasedPackage(packageToRestore);
          }
        }
      }
    } else if (personalAccount) {
      const storedPersonalPackage = localStorage.getItem("purchasedPackage");
      console.log("[Subscription Mount] Personal mode - stored package:", storedPersonalPackage);
      
      if (storedPersonalPackage && storedPersonalPackage !== "null" && storedPersonalPackage !== "{}") {
        try {
          const parsed = JSON.parse(storedPersonalPackage);
          console.log("[Subscription Mount] Restoring personal package from localStorage:", parsed);
          
          if (parsed && Object.keys(parsed).length > 0) {
            setPurchasedPackage(parsed);
          }
        } catch (e) {
          console.error("[Subscription Mount] Error parsing stored personal package:", e);
        }
      } else if (loggedUser?.package_details?.length > 0) {
        // Fallback: restore from loggedUser if localStorage is empty
        const personalPackage = loggedUser.package_details.find(
          (pkg) => pkg.team_id === null
        );
        
        if (personalPackage) {
          const packageToRestore = personalPackage?.package || personalPackage;
          console.log("[Subscription Mount] Restoring from loggedUser.package_details:", packageToRestore);
          
          if (packageToRestore && Object.keys(packageToRestore).length > 0) {
            localStorage.setItem("purchasedPackage", JSON.stringify(packageToRestore));
            setPurchasedPackage(packageToRestore);
          }
        }
      }
    }
  }, []); // Empty deps - run ONCE on mount

  // null end_date means never-expiring (e.g. customer_specific_owner with is_never_ending)
  const isExpired = activePurchasedPackage?.end_date
    ? new Date(activePurchasedPackage.end_date) < currentDate
    : false;
  const formattedDate = creationDate.toLocaleString();
  console.log("isExpired", isExpired);
  // const handleCheckboxChangeMonthly = () => {
  //   setHasCouponMonthly((prev) => !prev);
  // };
  // const handleCheckboxChangeYearly = () => {
  //   setHasCouponYearly((prev) => !prev);
  // };

  const handleCheckboxChangeMonthly = (index) => {
    setHasCouponMonthly((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  const handleCheckboxChangeYearly = (index) => {
    setHasCouponYearly((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  const handleTabSelect = (subscriptionIndex, key) => {
    setActiveKeys((prevActiveKeys) => {
      // Create a copy of the previous activeKeys array
      const updatedActiveKeys = [...prevActiveKeys];
      // Update the active key for the corresponding subscription
      updatedActiveKeys[subscriptionIndex] = key;
      return updatedActiveKeys;
    });
  };

  useEffect(() => {
    setCorrectCouponEntered(false);
    setIncorrectCouponEntered(false);
  }, [activeKeys]);

  const handleCouponInputChange = (event) => {
    setCouponCode(event.target.value);
  };
  // const applyCoupon = async () => {
  //   setLoading(true);
  //   const payload = {
  //     // package_id:,
  //     coupon_code:couponCode,
  //     subscription_type: selectedSubscriptionType,
  //   };
  //   let { status, message, data } = await post(
  //     COUPON_APPLY,
  //     payload,
  //     Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //   );
  //   if (status) {
  //     console.log("COUPON_APPLY", data);
  //   }
  // };

  const applyCoupon = async (subscriptionType, packageId) => {
    if (!couponCode) {
      setBlankCouponField(true);
      return;
    }
    // setLoading(true);
    setCorrectCouponEntered(false);
    setIncorrectCouponEntered(false);

    const payload = {
      package_id: packageId,
      coupon_code: couponCode,
      subscription_type: subscriptionType,
    };
    let { status, message, data } = await post(
      COUPON_APPLY,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setCorrectCouponEntered(true);
      setCouponData(data);
      setCouponMessage(message);
    } else {
      setIncorrectCouponEntered(true);
      setCouponMessage(message);
    }
  };

  // const getSubscriptionDetails = async () => {
  //   const payload = {
  //     user_id: loggedUser.id,
  //     team_id: null,
  //   };
  //   let { status, message, data } = await post(
  //     GET_USER_SUBSCRIPTION,
  //     payload,
  //     Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //   );

  //   if (status) {
  //     setPurchasedPackage(data[0]?.package);
  //   } else {
  //     showToast(status, message);
  //   }
  // };

  const getSubscriptionDetails = async () => {
    // In team mode, userID atom is set to loggedUser?.teams?.user_id
    const effectiveUserId = (!personalAccount && userID) ? userID : loggedUser.id;
    const payload = {
      user_id: effectiveUserId,
      team_id: !personalAccount && userTeamId ? userTeamId : null,
    };
    
    let { status, message, data } = await post(
      GET_USER_SUBSCRIPTION,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      const subscription = data[0];
      if (!subscription) {
        return;
      }
      const packageData = subscription.package;
      setPurchasedPackageData(data[0]);

      if (
        packageData?.is_free_trail === 1 &&
        subscription?.is_free_trial_used === 1
      ) {
        const freeTrialEndDate = subscription?.end_date;
        const formattedEndDate = freeTrialEndDate
          ? new Date(freeTrialEndDate.replace(" ", "T")).toLocaleString()
          : "";
        setFreeTrialMessage(
          `Your free trial is currently active and will expire on ${formattedEndDate}`
        );
      } else {
        setFreeTrialMessage("");
      }

      setActivePurchasedPackage(packageData);
      
      // CRITICAL FIX: Force persist to localStorage to prevent data loss
      if (packageData && Object.keys(packageData).length > 0) {
        if (!personalAccount) {
          localStorage.setItem("teamPurchasedPackage", JSON.stringify(packageData));
          localStorage.setItem("purchasedPackage", JSON.stringify(packageData));
          console.log("[Subscription] Force persisting team package to localStorage:", packageData);
        } else {
          localStorage.setItem("purchasedPackage", JSON.stringify(packageData));
          console.log("[Subscription] Force persisting personal package to localStorage:", packageData);
        }
      }
    }
  };

  const handlePayment = async (obj, subscription_type) => {
    if (
      ((deviceType === "android" || deviceType === "ios") &&
        !isExpired &&
        !autoRenew) ||
      ((deviceType === "android" || deviceType === "ios") && autoRenew)
    ) {
      setShowWarningModal(true);
      return;
    }

    // Auto-purchase zero-price packages without showing card details modal
    const price =
      subscription_type === "monthly"
        ? Number(obj?.price_monthly)
        : subscription_type === "yearly"
        ? Number(obj?.price_yearly)
        : Number(obj?.price);

    if (price === 0) {
      setLoading(true);
      const paymentObj = {
        amount: 0,
        auto_renew: false,
        duration: obj?.duration,
        package_id: obj?.id,
        coupon_code: null,
        coupon_code_id: null,
        discount: 0,
        discount_amount: 0,
        original_amount: 0,
        subscription_type: subscription_type,
      };
      const endpoint = `${TRANSACTION}/${
        [1, 2, 3].includes(obj.id) ||
        obj.package_type === "customer_specific_personal"
          ? "individualUserProcessPayment"
          : "processPayment"
      }`;
      const { status, message } = await post(
        endpoint,
        paymentObj,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
      if (status) {
        showToast(true, message);
        await getSubscriptionDetails();
      } else {
        showToast(false, message);
      }
      setLoading(false);
      return;
    }

    setSelectedPackage(obj);
    setSelectedSubscriptionType(subscription_type);
    setShowModal(true);
  };

  const handleCloseModal = async (success = false) => {
    setShowModal(false);
    if (success) {
      await getSubscriptionDetails();
    }
  };

  const handleCloseCancelModal = () => {
    if (
      ((deviceType === "android" || deviceType === "ios") &&
        !isExpired &&
        !autoRenew) ||
      ((deviceType === "android" || deviceType === "ios") && autoRenew)
    ) {
      setShowWarningModal(false);
    } else {
      setShowCancelModal(false);
    }
  };

  const handleCancelSubscription = () => {
    if (activePurchasedPackage) {
      trackEvent("Cancel Subscription Clicked", {
        device_type: deviceType,
        is_expired: isExpired,
        auto_renew: autoRenew,
        platform: "web",
        package: activePurchasedPackage,
      });
    }
    if (
      ((deviceType === "android" || deviceType === "ios") &&
        !isExpired &&
        !autoRenew) ||
      ((deviceType === "android" || deviceType === "ios") && autoRenew)
    ) {
      setShowWarningModal(true);
    } else {
      setShowCancelModal(true);
    }
  };

  const handleConfirmDelete = async () => {
    setCancelLoading(true);
    const payload = {
      device_type: "web",
      team_id: teamId,
    };
    let { status, message, data } = await post(
      CANCEL_SUBSCRIPTION,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      trackEvent("Subscription Cancelled", {
        ...data,
        platform: "web",
      });
      setPurchasedPackage(data.package); // always update personal atom on cancel
      showToast(true, message);
      setShowCancelModal(false);
    } else {
      showToast(false, message);
    }
    setCancelLoading(false);
  };

  useEffect(() => {
    // Fetch subscription details from API
    getSubscriptionDetails();
    
    if (loggedUser) {
      setDeviceType(loggedUser?.package_details[0]?.device_type);
      setAutoRenew(
        loggedUser?.package_details[0]?.auto_renew === 1 ? true : false
      );
    }
  }, [personalAccount, userTeamId]); // Re-fetch when account type or team changes

  // When in team mode, fetch packages from API with team_id instead of using cached atom data
  useEffect(() => {
    if (!personalAccount && userTeamId) {
      const fetchTeamPackages = async () => {
        setLoading(true);
        const queryString = `?user_id=${userID || loggedUser?.id}&team_id=${userTeamId}`;
        let { status, message, data } = await get(
          PACKAGES_LISTING + queryString,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );
        if (status && data) {
          const ownerPackages = data.filter(
            (pkg) =>
              pkg.package_type === "owner" ||
              pkg.package_type === "customer_specific_owner"
          );
          setSubscriptions(ownerPackages);
        } else {
          showToast(status, message);
        }
        setLoading(false);
      };
      fetchTeamPackages();
    } else if (personalAccount) {
      setSubscriptions(purchasePackages);
    }
  }, [personalAccount, userTeamId]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="heading">
        <h1>Packages</h1>
      </div>
      {
        // freeTrialMessage ? (
        //   <Card className="subscriptionCard mb-4 shadow-none">
        //     <Card.Body className="py-2">
        //       <div className="d-flex align-items-center">
        //         <RxExclamationTriangle />
        //         <p className="ms-3">{freeTrialMessage}</p>
        //       </div>
        //     </Card.Body>
        //   </Card>
        // ) :
        activePurchasedPackage?.id !== 1 ? (
          <Card className="subscriptionCard mb-4 shadow-none">
            <Card.Body className="py-2">
              {activePurchasedPackage?.end_date !== null ? (
                <p className="infoText">
                  {isExpired ? (
                    <div className="d-flex align-items-center">
                      <RxExclamationTriangle />
                      <p className="mt-3">
                        Your subscription has expired on {formattedDate}
                      </p>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <RxExclamationTriangle />
                      <p className="ms-3">
                        Your purchased package will end on {formattedDate}
                        <br />
                        Your subscription was purchased through the mobile app.
                        To upgrade or downgrade your subscription, please open
                        the mobile app and manage your subscription from there.
                      </p>
                    </div>
                  )}
                </p>
              ) : (
                ""
              )}
            </Card.Body>
          </Card>
        ) : (
          ""
        )
      }

      <div className="row g-4">
        <div className="col-12">
          <Tab.Container
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
          >
            <Nav variant="tabs" className="mb-3">
              <Nav.Item>
                <Nav.Link eventKey="monthly">Monthly</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="yearly">Yearly</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="customer_specific_personal">
                  Custom
                </Nav.Link>
              </Nav.Item>
            </Nav>

            {/* <Tab.Content>
              {["monthly", "yearly", "customer_specific_personal"].map(
                (type) => (
                  <Tab.Pane eventKey={type} key={type}>
                    {console.log("type", type)}
                    <Row className="row g-4">
                      {console.log("-----------", subscriptions)}
                      {subscriptions
                        // .filter(
                        //   (opt) =>
                        //     opt.package_type === "personal"
                        //   // || opt.package_type === "customer_specific_personal"
                        // )
                        .filter((opt) =>
                          opt.package_type === "customer_specific_personal"
                            ? "customer_specific_personal"
                            : opt.package_type === "personal"
                            ? "personal"
                            : ""
                        )
                        .map((singlePackage, index) => (
                          <>
                            {console.log("singlePackage", singlePackage)}
                            <SubscriptionCard
                              key={index}
                              index={index}
                              singlePackage={singlePackage}
                              purchasedPackage={activePurchasedPackage}
                              isExpired={isExpired}
                              subscriptionType={type}
                              isCouponChecked={
                                type === "monthly"
                                  ? hasCouponMonthly[index]
                                  : hasCouponYearly[index]
                              }
                              couponCode={couponCode}
                              onCheckboxChange={
                                type === "monthly"
                                  ? handleCheckboxChangeMonthly
                                  : handleCheckboxChangeYearly
                              }
                              onCouponChange={setCouponCode}
                              onApplyCoupon={applyCoupon}
                              onSelectPlan={handlePayment}
                              onCancelSubscription={handleCancelSubscription}
                              incorrectCouponEntered={incorrectCouponEntered}
                              correctCouponEntered={correctCouponEntered}
                              couponData={couponData}
                              setCouponData={setCouponData}
                              blankCouponField={blankCouponField}
                              setBlankCouponField={setBlankCouponField}
                              couponMessage={couponMessage}
                            />
                          </>
                        ))}
                    </Row>
                  </Tab.Pane>
                )
              )}
            </Tab.Content> */}

            {/* <Tab.Content>
              {["monthly", "yearly", "customer_specific_personal"].map(
                (type) => (
                  <Tab.Pane eventKey={type} key={type}>
                    <Row className="row g-4">
                      {subscriptions
                        .filter((opt) => {
                          if (type === "monthly") {
                            return (
                              opt.package_type === "personal" &&
                              (Number(opt.price_monthly) > 0 ||
                                opt.package_name === "Starter" ||
                                opt.package_name === "Enterprise")
                            );
                          }
                          if (type === "yearly") {
                            return (
                              opt.package_type === "personal" &&
                              (Number(opt.price_yearly) > 0 ||
                                opt.package_name === "Starter" ||
                                opt.package_name === "Enterprise")
                            );
                          }
                          if (type === "customer_specific_personal") {
                            return (
                              opt.package_type === "customer_specific_personal"
                            );
                          }
                          return false;
                        })
                        .map((singlePackage, index) => (
                          <SubscriptionCard
                            key={index}
                            index={index}
                            singlePackage={singlePackage}
                            purchasedPackage={activePurchasedPackage}
                            isExpired={isExpired}
                            subscriptionType={type}
                            isCouponChecked={
                              type === "monthly"
                                ? hasCouponMonthly[index]
                                : hasCouponYearly[index]
                            }
                            couponCode={couponCode}
                            onCheckboxChange={
                              type === "monthly"
                                ? handleCheckboxChangeMonthly
                                : handleCheckboxChangeYearly
                            }
                            onCouponChange={setCouponCode}
                            onApplyCoupon={applyCoupon}
                            onSelectPlan={handlePayment}
                            onCancelSubscription={handleCancelSubscription}
                            incorrectCouponEntered={incorrectCouponEntered}
                            correctCouponEntered={correctCouponEntered}
                            couponData={couponData}
                            setCouponData={setCouponData}
                            blankCouponField={blankCouponField}
                            setBlankCouponField={setBlankCouponField}
                            couponMessage={couponMessage}
                            purchasedPackageData={purchasedPackageData}
                          />
                        ))}
                    </Row>
                  </Tab.Pane>
                )
              )}
            </Tab.Content> */}
            <Tab.Content>
              {["monthly", "yearly", "customer_specific_personal"].map(
                (type) => {
                  const filteredPackages = subscriptions.filter((opt) => {
                    // In team mode, show owner packages; in personal mode, show personal packages
                    if (!personalAccount) {
                      if (type === "monthly") {
                        return (
                          opt.package_type === "owner" &&
                          (Number(opt.price_monthly) > 0 ||
                            opt.package_name === "Starter" ||
                            opt.package_name === "Enterprise")
                        );
                      }
                      if (type === "yearly") {
                        return (
                          opt.package_type === "owner" &&
                          (Number(opt.price_yearly) > 0 ||
                            opt.package_name === "Starter" ||
                            opt.package_name === "Enterprise")
                        );
                      }
                      if (type === "customer_specific_personal") {
                        return opt.package_type === "customer_specific_owner";
                      }
                      return false;
                    }

                    // Personal mode filters (unchanged)
                    if (type === "monthly") {
                      return (
                        opt.package_type === "personal" &&
                        (Number(opt.price_monthly) > 0 ||
                          opt.package_name === "Starter" ||
                          opt.package_name === "Enterprise")
                      );
                    }
                    if (type === "yearly") {
                      return (
                        opt.package_type === "personal" &&
                        (Number(opt.price_yearly) > 0 ||
                          opt.package_name === "Starter" ||
                          opt.package_name === "Enterprise")
                      );
                    }
                    if (type === "customer_specific_personal") {
                      return opt.package_type === "customer_specific_personal";
                    }
                    return false;
                  });

                  return (
                    <Tab.Pane eventKey={type} key={type}>
                      <Row className="row g-4">
                        {filteredPackages.length > 0 ? (
                          filteredPackages.map((singlePackage, index) => (
                            <SubscriptionCard
                              key={index}
                              index={index}
                              singlePackage={singlePackage}
                              purchasedPackage={activePurchasedPackage}
                              isExpired={isExpired}
                              subscriptionType={type}
                              isCouponChecked={
                                type === "monthly"
                                  ? hasCouponMonthly[index]
                                  : hasCouponYearly[index]
                              }
                              couponCode={couponCode}
                              onCheckboxChange={
                                type === "monthly"
                                  ? handleCheckboxChangeMonthly
                                  : handleCheckboxChangeYearly
                              }
                              onCouponChange={setCouponCode}
                              onApplyCoupon={applyCoupon}
                              onSelectPlan={handlePayment}
                              onCancelSubscription={handleCancelSubscription}
                              incorrectCouponEntered={incorrectCouponEntered}
                              correctCouponEntered={correctCouponEntered}
                              couponData={couponData}
                              setCouponData={setCouponData}
                              blankCouponField={blankCouponField}
                              setBlankCouponField={setBlankCouponField}
                              couponMessage={couponMessage}
                              purchasedPackageData={purchasedPackageData}
                            />
                          ))
                        ) : type === "customer_specific_personal" ? (
                          <div className="text-center py-4">
                            <p className="text-muted">No package found</p>
                          </div>
                        ) : null}
                      </Row>
                    </Tab.Pane>
                  );
                }
              )}
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
      {showModal && (
        <SubscriptionModal
          show={showModal}
          stripePromise={stripePromise}
          handleCloseModal={handleCloseModal}
          selectedPackage={selectedPackage}
          selectedSubscriptionType={selectedSubscriptionType}
          elementsOptions={elementsOptions}
          couponData={couponData}
        />
      )}
      <Modal
        show={showCancelModal}
        onHide={handleCloseCancelModal}
        aria-labelledby="contained-modal-title-vcenter"
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header
          className="modalHeader flex justify-content-between"
          style={{ borderBottom: "none", width: "fit-content" }}
        >
          <div className="modalGradientCircle"></div>
          <span
            className="modalHeading"
            style={{ fontWeight: "600", color: "var(--primary_text_color)", fontSize: "20px" }}
          >
            Like to cancel your subscription?
          </span>

          {/* <MdClose onClick={handleCloseCancelModal} className="modalCloseBtn" /> */}
        </Modal.Header>

        <Modal.Body
          className={`d-flex justify-content-center flex-column align-items-center`}
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
              width: "fit-content",
              lineHeight: "18px",
            }}
          >
            <h5>Are you sure?</h5>
            <p
              style={{
                lineHeight: "18px",
                textAlign: "center",
                padding: "0px 20px",
              }}
            >
              Are you sure you want to cancel your Subscription
            </p>
          </div>

          <div className="mobileViewWrapper mt-4 pb-3">
            <Button
              variant="outline-primary"
              onClick={handleCloseCancelModal}
              className=" mx-3"
            >
              No, Keep it
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirmDelete}
              className="primary_button"
              disabled={cancelLoading}
            >
              {cancelLoading ? "Please Wait.." : "Cancel Subscription"}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showWarningModal}
        onHide={handleCloseCancelModal}
        aria-labelledby="contained-modal-title-vcenter"
        className="customModal"
        size="sm"
      >
        <Modal.Header>
          <div className="modalGradientCircle"></div>
          <MdClose onClick={handleCloseCancelModal} className="modalCloseBtn" />
        </Modal.Header>

        <Modal.Body
          style={{ padding: "0" }}
          className={`d-flex justify-content-center flex-column align-items-center`}
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ width: "fit-content", lineHeight: "18px" }}
          >
            <p
              style={{
                lineHeight: "18px",
                textAlign: "center",
                padding: "0px 20px",
              }}
            >
              Your subscription was purchased through the mobile app on an{" "}
              {deviceType} device. To upgrade or downgrade your subscription,
              please open the mobile app and manage your subscription from
              there.
            </p>
          </div>

          <div className={`customModalBtnWrapper btnWrapper`}>
            <Button
              onClick={handleCloseCancelModal}
              style={{
                background: "#E35252",
                boxShadow: "0px 6px 20px rgba(227, 82, 82, 0.4)",
              }}
            >
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Subscription;
